// services/orderService.js - TÜM URL'LERİ BU ŞEKİLDE DEĞİŞTİRİN

class OrderService {
  async getOrderById(id) {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders/${id}`); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Order detayı getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Order detayı getirme hatası:', error);
      throw error;
    }
  }

  async getAllOrders(page = 0, size = 20, sortBy = 'orderDate', direction = 'desc') {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Order listesi getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Order listesi getirme hatası:', error);
      throw error;
    }
  }

  async getOrdersWithFilters(status, customerEmail, startDate, endDate, page = 0, size = 10) {
    try {
      const params = new URLSearchParams();
      if (status) params.append('status', status);
      if (customerEmail) params.append('customerEmail', customerEmail);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      params.append('page', page);
      params.append('size', size);

      const url = `https://medi-panel.cloud/api/orders/filtered?${params.toString()}`;
      console.log('🔍 API Call:', url);

      const response = await fetch(url);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('❌ API Error:', response.status, errorText);
        throw new Error(`Filtreli order listesi getirilemedi: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('❌ Filtreli order listesi getirme hatası:', error);
      throw error;
    }
  }

  async getOrdersByStatus(status) {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders/status/${status}`); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Status\'a göre order listesi getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Status order listesi getirme hatası:', error);
      throw error;
    }
  }

  async getOrdersByCustomerEmail(email) {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders/customer/${email}`); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Müşteriye göre order listesi getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Müşteri order listesi getirme hatası:', error);
      throw error;
    }
  }

  async syncOrders() {
    try {
      const response = await fetch('https://medi-panel.cloud/api/orders/sync', { // 🔥 TAM URL
        method: 'POST'
      });
      if (!response.ok) {
        throw new Error('Order sync başarısız');
      }
      return await response.text();
    } catch (error) {
      console.error('❌ Order sync hatası:', error);
      throw error;
    }
  }

  async updateOrder(id) {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders/${id}/sync`, { // 🔥 TAM URL
        method: 'PUT'
      });
      if (!response.ok) {
        throw new Error('Order güncelleme başarısız');
      }
      return await response.text();
    } catch (error) {
      console.error('❌ Order güncelleme hatası:', error);
      throw error;
    }
  }

  async getOrderStats() {
    try {
      const response = await fetch('https://medi-panel.cloud/api/orders/stats'); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Order istatistikleri getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Order istatistikleri getirme hatası:', error);
      throw error;
    }
  }

  async getRecentOrders(count = 10) {
    try {
      const response = await fetch(`https://medi-panel.cloud/api/orders/recent?count=${count}`); // 🔥 TAM URL

      if (!response.ok) {
        throw new Error('Son order\'lar getirilemedi');
      }
      return await response.json();
    } catch (error) {
      console.error('❌ Son order\'lar getirme hatası:', error);
      throw error;
    }
  }

  // 🔥 YENİ: Purchase Order'ı PDF ile birlikte kaydet (BU ZATEN DOĞRU)
  async savePurchaseOrderWithPDF(poData, orderId) {
    try {
      console.log('💾 Purchase Order PDF ile kaydediliyor...', {
        orderId,
        originalPONumber: poData.poNumber
      });

      const htmlContent = document.getElementById('purchase-order').innerHTML;
      const pdfBase64 = btoa(unescape(encodeURIComponent(htmlContent)));

      const requestBody = {
        orderId: orderId,
        poData: poData,
        pdfData: pdfBase64,
        fileName: `${poData.poNumber}.html`
      };

      const response = await fetch('https://medi-panel.cloud/api/purchase-orders/with-pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText}`);
      }

      const result = await response.json();

      // 🔥 YENİ: Backend'den gelen yeni PO number'ı logla
      console.log('✅ Purchase Order PDF ile kaydedildi:', {
        originalPONumber: poData.poNumber,
        newPONumber: result.poNumber, // 🔥 Backend'den gelen yeni number
        poId: result.poId
      });

      return result;

    } catch (error) {
      console.error('❌ Purchase Order kaydetme hatası:', error);
      throw error;
    }

  }
}

export default new OrderService();